import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './FormDropDownList.scss';
import FormField from './FormField';
import DropDownList from '../DropDownList';

export default class FormDropDownList extends Component {
    static propTypes = {
        label: PropTypes.string,
        value: PropTypes.any,
        items: PropTypes.array,
        formatter: PropTypes.func,
        searchable: PropTypes.bool,
        canBeNotSelected: PropTypes.bool,
        multipleSelection: PropTypes.bool,
        multipleFormatter: PropTypes.func,
        error: PropTypes.string,
        disabled: PropTypes.bool,
        onChange: PropTypes.func,
        className: PropTypes.string,
        customClassName: PropTypes.any
    };

    render() {
        const {label, error, className, ...dropDownProps} = this.props;
        const fieldClassName = classnames(styles.container, className);

        return (
            <FormField label={label} error={error}
                       className={fieldClassName}>
                <DropDownList {...dropDownProps} className={styles.field}
                              error={error}/>
            </FormField>
        );
    }

}



// WEBPACK FOOTER //
// ./src/components/controls/form/FormDropDownList.jsx